import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Validators, FormControl } from "@angular/forms";
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { ItemServiceService } from 'src/app/POS/POSServices/Setup/item-service.service';
const swal = require('sweetalert');
@Component({
  selector: 'app-item-category',
  templateUrl: './item-category.component.html',
  styleUrls: ['./item-category.component.scss']
})
export class ItemCategoryComponent implements OnInit {
  HSNCode= new FormControl("", []);
  isReadytoUpdateCustomer : boolean = false;
  row=[]
  CategoryNameerrormessage:boolean=false;
  list = [];
  DateTime;
  merchantdata: UserPOSData ;
  date=new FormControl("", [Validators.required]);
  isNewcategory: boolean = true;
  isUpdatecategory: boolean = false;
  rows;
  mystring="";
  myDouble="";
  TaxType=new FormControl("", [Validators.required]);
  str_array:any[];
  CategoryName= new FormControl("", [Validators.required, Validators.maxLength(50), Validators.minLength(1)]);

  // , Validators.pattern("^(?! )[a-zA-Zs ]*$")


  customerId = new FormControl("", [Validators.required]);
  id= new FormControl("", [Validators.required]);
CustomerId = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: ItemServiceService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetcategoryDetails();
    this.getGetcategorytaxfeeDetails();
  }
  getGetcategorytaxfeeDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   
    this.service.GetCategoryTaxFeeList(form).subscribe(result => {  
      this.row = result;
    // for(var i=0;i<=result.length;i++)
    // {
    //    this.mystring = result[i].TaxRate+',';
    //    this.myDouble =this.myDouble+this.mystring;
    //    this.str_array =this.myDouble.split(',');
    //    this.list = this.str_array ;
    // }
      console.log("result.Id---" + result);
      //  if (result[i].Id > 0) {
       
      //   this.rows = result;
      // } else {
      
      // }
    });
 
  }

  getGetcategoryDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);

    });   

    if( form.id != undefined &&  form.id != null )
    {

    if( form.id != undefined &&  form.id != null ){

      this.service.GetItemCategoryDetail(form).subscribe(result => {   
        console.log("result.Id---" + result);
         if (result.Id > 0) {
          this.DateTime=result.DateTime;
          this.isUpdatecategory = true;
          this.isNewcategory = false;
          this.rows = result;
  
        } else {
          this.isUpdatecategory = false;
          this.isNewcategory = true;
        }

      }); 
    }

    // this.service.GetItemCategoryDetail(form).subscribe(result => {   
    //   console.log("result.Id---" + result);
    //    if (result.id > 0) {
    //     this.DateTime=result.dateTime;
    //     this.isUpdatecategory = true;
    //     this.isNewcategory = false;
    //     this.rows = result;

    //   } else {
    //     this.isUpdatecategory = false;
    //     this.isNewcategory = true;
    //   }
    // });

    }   

    

 
  }
  onChanges()
  {
    let form = { merchantKeyId: "", CategoryName:"", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      // form.id = params["id"];
  
      form.CategoryName = this.CategoryName.value;
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetCategoryName(form).subscribe(result => {   
      if(result==null)
      {
         this.CategoryNameerrormessage=false;
      }
      else{
        this.CategoryNameerrormessage=true;
    
      }
    });
 
  }

  newcategory() {
    let form = {
      CategoryName:"",
    CustomerId :"",
    PosSubscriptionId:"",
    TaxType:"",
    HSNCode:"",
    };
    form.HSNCode = this.HSNCode.value;
    form.CustomerId = this.CustomerId.value;
    form.CategoryName = this.CategoryName.value;
    form.TaxType = this.TaxType.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.CustomerId = merchantdata.PosSubscriptionId;
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.AddItemCategory(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        var length = +localStorage.getItem('orderlength')
        if(length>0)
        {
          localStorage.removeItem('Getitemcategorylist');
        swal("Added", "Item Category Added Successfully", "success"); 
        this.router.navigate(["pos/category/manage"]);
        }
        else
        {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
  }

  updatecategory()
  {
      let form = {
        CategoryName:"",
      CustomerId :"",
      Id:"",
      TaxType:"",
      PosSubscriptionId:"",
      DateTime:"",
      HSNCode:"",

    };
    form.HSNCode = this.HSNCode.value;
    form.Id=this.id.value;
     form.CustomerId = this.CustomerId.value;
    form.CategoryName = this.CategoryName.value;
    form.TaxType=this.TaxType.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    form.DateTime=this.DateTime;
    this.service.UpdateItemCategory(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        var length = +localStorage.getItem('orderlength')
        if(length>0)
        {
          localStorage.removeItem('Getitemcategorylist');
        swal("Updated", "Item Category Updated Successfully", "success"); 
        this.router.navigate(["pos/category/manage"]);
        }
        else
        {
          this.router.navigate(["/pos/setup"]);
        }
      }
    });
  }
  itemcategory() {
    return this.CategoryName.hasError("required") ? "Category Name  is required"
      : this.CategoryName.hasError("pattern") ? "Category Name should be allow only alphabets" : "";
  }
  TaxTypeerrors()
  {
    return this.TaxType.hasError("required") ? "TaxType  is required": "";
    

  }
  clearcache()
{
  localStorage.removeItem('Customerlist');
  window.location.reload();
}
onKey()
  {
    this.isReadytoUpdateCustomer = true;
  }
}
